import { render, staticRenderFns } from "./EmployeesIncreaseTendency.vue?vue&type=template&id=48cab14f&scoped=true&"
import script from "./EmployeesIncreaseTendency.vue?vue&type=script&lang=js&"
export * from "./EmployeesIncreaseTendency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cab14f",
  null
  
)

export default component.exports